/* Vélo Klub: één achtergrond voor alle productfoto's.
   - doeltint (23/10): #F2F2F0, exact dezelfde tint als de productfoto's van Erstwhile (en de nieuwe Bodhi-foto's)
   - de kadertint en 'darken' staan al in de stijlregels van het thema (snippets/vk-fonts.liquid).
   - productfoto's worden pas getoond (zachte fade) nadat dit script ze bekeken heeft, zodat je nooit eerst
     de verkeerde achtergrondtint ziet. Valt het script weg, dan verschijnen ze toch na 1,2 seconde (stijlregels).
   - foto's met een effen achtergrond die DONKERDER is dan de kadertint worden naar exact #F2F2F0 getrokken.
   - vierkante packshots: volledig tonen in het staande kader (niet bijsnijden)
   - sfeerfoto's: ongewijzigd, wel kadervullend
   - 23/10: foto's met een eigen uitsnede (class vk-cardfit, metafield custom.card_fit op het product, bv. voeding of
     de Bodhi-sokken): altijd volledig tonen (nooit bijsnijden of kadervullend); de uitsnede zelf staat in de foto
     (transform). Een effen achtergrond wordt wel nog naar de kadertint getrokken, zodat er geen rand zichtbaar is. */
(function(){
  var T=[242,242,240];                 /* doeltint van alle kaders: #F2F2F0 */
  var TC='rgb('+T.join(',')+')';
  var st=document.createElement('style');
  st.textContent='img.vk-fit{object-fit:contain!important;object-position:50% 50%!important}img.vk-norm{mix-blend-mode:normal!important}img.vk-cover{object-fit:cover!important;mix-blend-mode:normal!important}.vk-normbg{background-color:'+TC+'!important}';
  document.head.appendChild(st);
  var NS='http://www.w3.org/2000/svg',defs=null,fid={};
  function filterFor(c){
    var k=c.join('-'); if(fid[k]) return fid[k];
    if(!defs){var s=document.createElementNS(NS,'svg');s.setAttribute('width','0');s.setAttribute('height','0');s.setAttribute('aria-hidden','true');s.style.position='absolute';defs=document.createElementNS(NS,'defs');s.appendChild(defs);document.body.appendChild(s);}
    var f=document.createElementNS(NS,'filter'),id='vkn'+k;f.setAttribute('id',id);f.setAttribute('color-interpolation-filters','sRGB');
    var m=document.createElementNS(NS,'feColorMatrix');m.setAttribute('type','matrix');
    var r=T[0]/c[0],g=T[1]/c[1],b=T[2]/c[2];
    m.setAttribute('values',r.toFixed(4)+' 0 0 0 0  0 '+g.toFixed(4)+' 0 0 0  0 0 '+b.toFixed(4)+' 0 0  0 0 0 1 0');
    f.appendChild(m);defs.appendChild(f);return fid[k]='url(#'+id+')';
  }
  var SEL='.vk-card__media img, .vk-mega__card img, .vk-gallery__item img, .vk-siblings img, [data-vk-fit] img';
  var cache={};
  function edge(src,cb){
    var u=src.replace(/([?&])width=\d+/,'$1width=40');
    if(u===src) u=src+(src.indexOf('?')>-1?'&':'?')+'width=40';
    var e=cache[u]; if(e){ if(e.q) e.q.push(cb); else cb(e.v); return; }
    e=cache[u]={q:[cb]};
    var done=function(v){e.v=v;var q=e.q;e.q=null;q.forEach(function(f){f(v)})};
    var im=new Image();im.crossOrigin='anonymous';
    im.onload=function(){try{
      var c=document.createElement('canvas'),w=c.width=im.naturalWidth,h=c.height=im.naturalHeight,x=c.getContext('2d',{willReadFrequently:true});
      x.drawImage(im,0,0);
      var P=[[.02,0],[.25,0],[.5,0],[.75,0],[.98,0],[.02,.1],[.02,.3],[.02,.5],[.02,.7],[.98,.1],[.98,.3],[.98,.5],[.98,.7],[.02,.98],[.98,.98]],px=[];
      P.forEach(function(p){var d=x.getImageData(Math.min(w-1,Math.round(p[0]*w)),p[1]?Math.min(h-2,Math.round(p[1]*h)):1,1,1).data;px.push([d[0],d[1],d[2]])});
      var med=[0,1,2].map(function(i){var a=px.map(function(c){return c[i]}).sort(function(a,b){return a-b});return a[a.length>>1]});
      var near=px.filter(function(c){return Math.max(Math.abs(c[0]-med[0]),Math.abs(c[1]-med[1]),Math.abs(c[2]-med[2]))<=12}).length;
      done({c:med,flat:near>=12&&Math.min.apply(null,med)>=170});
    }catch(err){done(null)}};
    im.onerror=function(){done(null)};
    im.src=u;
  }
  function ready(img){ img.classList.add('vk-ready'); }
  function fit(img){
    if(img.dataset.vkFit) return;
    var own=img.classList.contains('vk-cardfit');
    var go=function(){
      var w=img.naturalWidth,h=img.naturalHeight; if(!w||!h){ ready(img); return; }
      img.dataset.vkFit='1';
      var square=h/w<=1.15, box=img.parentElement;
      if(square||own) img.classList.add('vk-fit');
      edge(img.currentSrc||img.src,function(r){
        if(r){
          if(r.flat){
            box.classList.add('vk-normbg');
            var darker=(r.c[0]<T[0]-2)||(r.c[1]<T[1]-2)||(r.c[2]<T[2]-2);
            if(darker){ img.classList.add('vk-norm'); img.style.filter=filterFor(r.c); }
          } else if(!own){
            img.classList.remove('vk-fit');
            img.classList.add('vk-cover');   /* sfeerfoto: kadervullend */
          }
        }
        requestAnimationFrame(function(){ ready(img); });
      });
    };
    if(img.complete&&img.naturalWidth) go();
    else { img.addEventListener('load',go,{once:true}); img.addEventListener('error',function(){ready(img)},{once:true}); }
  }
  function scan(root){(root||document).querySelectorAll(SEL).forEach(fit)}
  function start(){
    scan();
    new MutationObserver(function(m){m.forEach(function(r){r.addedNodes.forEach(function(n){if(n.nodeType===1){ if(n.matches&&n.matches(SEL)) fit(n); else scan(n);}})})}).observe(document.documentElement,{childList:true,subtree:true});
  }
  if(document.body) start(); else document.addEventListener('DOMContentLoaded',start);
})();
